import './functions';
import './logic';
import './variables';
import './statics';
import { wrapperBuilder } from './build';

export const UserWrapper = wrapperBuilder.build();
